import { useCallback, useRef } from 'react'
import { useUpdate } from 'react-use'

export function useNodeRef() {
    const node = useRef<HTMLElement | null>(null)
    const update = useUpdate()

    const setNodeRef = useCallback(
        (element: HTMLElement | null) => {
            node.current = element
            update()
        },
        [update]
    )

    return [node, setNodeRef] as const
}
